import React from 'react';
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";

export class ActivityFeedTimeStamp extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const dateStringFormat = DateUtils.FormatToLocalDate(this.props.Event.created, "MMMM do h:mm a");
        const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        
        return <p className="sb-activity-feed-group-item-summary-time-stamp">
            {dateStringFormat} {timezoneName}
        </p>
    }
}


